import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://www.idealapis.biz',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem('user');
    const user = userData ? JSON.parse(userData) : null;
    if (user && user.token) {
      config.headers['Authorization'] = `Bearer ${user.token}`;
    } else {
      delete config.headers['Authorization']; // Ensure it’s removed if user logs out
    }
    return config;
  },
  (error) => Promise.reject(error)
);
